import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { App } from './App';
import { initializeIcons } from '@uifabric/icons';
initializeIcons();
ReactDOM.render(React.createElement(App, null), document.getElementById('root'));



//////////////////
// WEBPACK FOOTER
// ./src/index.tsx
// module id = 84
// module chunks = 0